export const filterAccountUserRows = <TRow>(
    rows: readonly TRow[],
    searchTerm: string,
    getSearchableValues: (row: TRow) => readonly (string | null | undefined)[],
): TRow[] => {
    const trimmedSearch = searchTerm.trim().toLowerCase();
    if (!trimmedSearch) {
        return [...rows];
    }

    return rows.filter((row) =>
        getSearchableValues(row).some((value) => (value ?? "").toLowerCase().includes(trimmedSearch)),
    );
};
